import useScreen from 'hooks/useScreen';

const useBreakpoint = (
  breakpoint: Exclude<keyof ReturnType<typeof useScreen>, 'width'>,
  ssrWidth?: number
) => {
  const screen = useScreen({ ssrWidth });
  if (!breakpoint) throw new Error(`Unknown breakpoint: ${screen}`);
  return screen[breakpoint];
};

export default useBreakpoint;
